import type { BookChatCitation } from '@/api/services/book-ai'

/** 根拠の場所の表示名（PDF はページ、EPUB は章の名前） */
export const citationLabel = (citation: BookChatCitation): string =>
  citation.location.page != null ? `p.${citation.location.page + 1}` : citation.section_title

/** 同じページ（章）の根拠が並ばないよう、表示名ごとに最初の 1 つだけにする */
export const uniqueCitations = <T extends BookChatCitation>(citations: T[]): T[] => {
  const seen = new Set<string>()
  return citations.filter((citation) => {
    const label = citationLabel(citation)
    if (seen.has(label)) return false
    seen.add(label)
    return true
  })
}
